/*

=========================================================
* Volt Pro - Premium Bootstrap 5 Dashboard
=========================================================

* Product Page: https://themesberg.com/product/admin-dashboard/volt-premium-bootstrap-5-dashboard
* Copyright 2021 Themesberg (https://www.themesberg.com)

* Designed and coded by https://themesberg.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. Please contact us to request a removal. Contact us if you want to remove it.

*/

import { formatCompactDate } from "@js/helper/dateHelper";

document.addEventListener("DOMContentLoaded", () => {
  const swalWithBootstrapButtons = cs.Swal.mixin({
    // Assuming cs is on window
    customClass: {
      confirmButton: "btn btn-primary me-3",
      cancelButton: "btn btn-secondary",
    },
    buttonsStyling: false,
  });

  const datepickerElements = document.querySelectorAll("[data-datepicker]");
  let datepickersList = [];
  if (datepickerElements && datepickerElements.length > 0) {
    datepickerElements.forEach((el) => {
      // Auto-format 8-digit date strings (e.g. "22111989" -> "22.11.1989")
      el.addEventListener("blur", function () {
        const formatted = formatCompactDate(this.value);
        if (formatted !== this.value) {
          this.value = formatted;
          this.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });

      // Klick auf das Kalender-Icon in .input-group öffnet ebenfalls den Datepicker
      const inputGroup = el.closest(".input-group");
      if (inputGroup) {
        const iconSpan = inputGroup.querySelector(".input-group-text");
        if (iconSpan) {
          iconSpan.style.cursor = "pointer";
          iconSpan.addEventListener("click", () => {
            el.focus();
          });
        }
      }
    });

    datepickersList = Array.from(datepickerElements).map((el) => {
      const modalParent = el.closest(".modal-content") || el.closest(".modal");
      return new cs.Datepicker(el, {
        buttonClass: "btn",
        language: "de",
        autohide: true,
        container: modalParent || document.body,
      });
    });
  }

  // options
  const breakpoints = {
    sm: 540,
    md: 720,
    lg: 960,
    xl: 1140,
  };

  const preloader = document.querySelector(".preloader");
  if (preloader) {
    setTimeout(() => {
      preloader.classList.add("show");

      setTimeout(() => {
        const loaderElement = document.querySelector(".loader-element");
        if (loaderElement) {
          loaderElement.classList.add("hide");
        }
      }, 100);
    }, 200);
  }

  document.querySelectorAll("[data-background]").forEach((el) => {
    el.style.background = `url(${el.getAttribute("data-background")})`;
  });

  document.querySelectorAll("[data-background-lg]").forEach((el) => {
    if (document.body.clientWidth > breakpoints.lg) {
      el.style.background = `url(${el.getAttribute("data-background-lg")})`;
    }
  });
  document.querySelectorAll("[data-background-color]").forEach((el) => {
    el.style.backgroundColor = el.getAttribute("data-background-color");
  });

  document.querySelectorAll("[data-color]").forEach((el) => {
    el.style.color = el.getAttribute("data-color");
  });

  //Tooltips
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  const tooltipList = Array.from(tooltipTriggerList).map(
    (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl),
  );

  // Popovers
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
  const popoverList = Array.from(popoverTriggerList).map(
    (popoverTriggerEl) => new bootstrap.Popover(popoverTriggerEl),
  );

  // Dropdowns in tables / .table-responsive: Use Popper fixed strategy to prevent clipping by overflow containers
  document.addEventListener("show.bs.dropdown", (event) => {
    const toggle = event.target;
    if (!toggle) return;
    if (toggle.closest(".table-responsive, table")) {
      const bs = window.bootstrap || (typeof bootstrap !== "undefined" ? bootstrap : null);
      if (bs?.Dropdown) {
        const dropdownInstance =
          bs.Dropdown.getInstance(toggle) || bs.Dropdown.getOrCreateInstance(toggle);
        if (dropdownInstance && dropdownInstance._config) {
          dropdownInstance._config.popperConfig = {
            strategy: "fixed",
            ...(typeof dropdownInstance._config.popperConfig === "object"
              ? dropdownInstance._config.popperConfig
              : {}),
          };
        }
      }
    }
  });

  // DataTables
  const dataTableEl = document.getElementById("datatable");
  if (dataTableEl) {
    const dataTable = new simpleDatatables.DataTable(dataTableEl); // eslint-disable-line no-unused-vars
  }

  if (document.querySelector(".input-slider-container")) {
    document.querySelectorAll(".input-slider-container").forEach((el) => {
      const slider = el.querySelector(":scope .input-slider");
      const sliderId = slider.getAttribute("id");
      const minValue = slider.getAttribute("data-range-value-min");
      const maxValue = slider.getAttribute("data-range-value-max");

      const sliderValue = el.querySelector(":scope .range-slider-value");
      const sliderValueId = sliderValue.getAttribute("id");
      const startValue = sliderValue.getAttribute("data-range-value-low");

      const sliderElement = document.getElementById(sliderId);
      // const valueElement = document.getElementById(sliderValueId); // Not directly used with noUiSlider create

      if (sliderElement) {
        noUiSlider.create(sliderElement, {
          start: [parseInt(startValue)],
          connect: [true, false],
          range: {
            min: [parseInt(minValue)],
            max: [parseInt(maxValue)],
          },
        });
      }
    });
  }

  const rangeSliderElement = document.getElementById("input-slider-range");
  if (rangeSliderElement) {
    const valueLowElement = document.getElementById("input-slider-range-value-low");
    const valueHighElement = document.getElementById("input-slider-range-value-high");

    if (valueLowElement && valueHighElement) {
      const valueElements = [valueLowElement, valueHighElement];
      noUiSlider.create(rangeSliderElement, {
        start: [
          parseInt(valueLowElement.getAttribute("data-range-value-low")),
          parseInt(valueHighElement.getAttribute("data-range-value-high")),
        ],
        connect: true,
        tooltips: true,
        range: {
          min: parseInt(rangeSliderElement.getAttribute("data-range-value-min")),
          max: parseInt(rangeSliderElement.getAttribute("data-range-value-max")),
        },
      });

      rangeSliderElement.noUiSlider.on("update", (values, handle) => {
        valueElements[handle].textContent = values[handle];
      });
    }
  }

  // Apex Charts

  //Main Chart
  const mainChartOptions = {
    chart: {
      height: 420,
      type: "area",
      fontFamily: "Inter",
      foreColor: "#4B5563",
      toolbar: {
        show: true,
        offsetX: 0,
        offsetY: 0,
        tools: {
          download: false,
          selection: false,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: false,
          reset: '<img src="/static/icons/reset.png" width="20">',
          customIcons: [],
        },
        export: {
          csv: {
            filename: undefined,
            columnDelimiter: ",",
            headerCategory: "category",
            headerValue: "value",
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString();
            },
          },
        },
        autoSelected: "zoom",
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      style: {
        fontSize: "14px",
        fontFamily: "Inter",
      },
    },
    theme: {
      monochrome: {
        enabled: true,
        color: "#f3c78e",
      },
    },
    grid: {
      show: true,
      borderColor: "#f5e1c5",
      strokeDashArray: 1,
    },
    series: [
      {
        name: "Sales",
        data: [95, 52, 78, 45, 19, 53, 60],
      },
    ],
    markers: {
      size: 5,
      strokeColors: "#ffffff",
      hover: {
        size: undefined,
        sizeOffset: 3,
      },
    },
    xaxis: {
      categories: ["01 Feb", "02 Feb", "03 Feb", "04 Feb", "05 Feb", "06 Feb", "07 Feb"],
      labels: {
        style: {
          fontSize: "12px",
          fontWeight: 500,
        },
      },
      axisBorder: {
        color: "#f5e1c5",
      },
      axisTicks: {
        color: "#f5e1c5",
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: ["#4B5563"],
          fontSize: "12px",
          fontWeight: 500,
        },
      },
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          yaxis: {
            show: false,
          },
        },
      },
    ],
  };

  const mainChartEl = document.querySelector("#chart");
  if (mainChartEl) {
    const mainChart = new ApexCharts(mainChartEl, mainChartOptions);
    mainChart.render();
  }

  // Weekly Sales Chart
  const optionsWeeklySalesChart = {
    series: [
      {
        name: "Sales",
        data: [32, 44, 37, 47, 42, 55, 47, 65],
      },
    ],
    chart: {
      type: "bar",
      width: "100%",
      height: 260,
      sparkline: {
        enabled: true,
      },
    },
    theme: {
      monochrome: {
        enabled: true,
        color: "#31316A",
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "20%",
        borderRadius: 5,
        radiusOnLastStackedBar: true,
        horizontal: false,
        distributed: false,
        // endindShape: 'rounded', // Typo: endingShape
        endingShape: "rounded",
        colors: {
          backgroundBarColors: ["#F2F4F6", "#F2F4F6", "#F2F4F6", "#F2F4F6"],
          backgroundBarRadius: 5,
        },
      },
    },
    labels: [1, 2, 3, 4, 5, 6, 7, 8],
    xaxis: {
      categories: ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5", "Week 6", "Week 7", "Week 8"],
      crosshairs: {
        width: 1,
      },
    },
    tooltip: {
      fillSeriesColor: false,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      theme: "light",
      style: {
        fontSize: "12px",
        fontFamily: "Inter",
      },
      y: {
        formatter: function (val) {
          return "$ " + val + "k";
        },
      },
    },
  };

  const weeklySalesChartEl = document.getElementById("chart-weekly-sales");
  if (weeklySalesChartEl) {
    const weeklySalesChart = new ApexCharts(weeklySalesChartEl, optionsWeeklySalesChart);
    weeklySalesChart.render();
  }

  //Customers Chart
  const optionsCustomersChart = {
    series: [
      {
        name: "Clients",
        data: [120, 160, 200, 470, 420, 150, 470, 750, 650, 190, 140],
      },
    ],
    labels: [
      "01 Feb",
      "02 Feb",
      "03 Feb",
      "04 Feb",
      "05 Feb",
      "06 Feb",
      "07 Feb",
      "08 Feb",
      "09 Feb",
      "10 Feb",
      "11 Feb",
    ],
    chart: {
      type: "area",
      width: "100%",
      height: 140,
      sparkline: {
        enabled: true,
      },
    },
    theme: {
      monochrome: {
        enabled: true,
        color: "#31316A",
      },
    },
    tooltip: {
      fillSeriesColor: false,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      theme: "light",
      style: {
        fontSize: "12px",
        fontFamily: "Inter",
      },
    },
  };

  const customersChartEl = document.getElementById("chart-customers");
  if (customersChartEl) {
    const customersChart = new ApexCharts(customersChartEl, optionsCustomersChart);
    customersChart.render();
  }

  //Today Users Chart
  const optionsUsersChart = {
    series: [
      {
        name: "Users",
        data: [520, 560, 500, 570, 520, 550, 570, 550, 550, 590, 540],
      },
    ],
    labels: [
      "06PM",
      "02 Feb",
      "03 Feb",
      "04 Feb",
      "05 Feb",
      "06 Feb",
      "07 Feb",
      "08 Feb",
      "09 Feb",
      "10 Feb",
      "11 Feb",
    ],
    chart: {
      type: "area",
      width: "100%",
      height: 140,
      sparkline: {
        enabled: true,
      },
    },
    theme: {
      monochrome: {
        enabled: true,
        color: "#31316A",
      },
    },
    tooltip: {
      fillSeriesColor: false,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      theme: "light",
      style: {
        fontSize: "12px",
        fontFamily: "Inter",
      },
    },
  };

  const usersChartEl = document.getElementById("chart-users");
  if (usersChartEl) {
    const usersChart = new ApexCharts(usersChartEl, optionsUsersChart);
    usersChart.render();
  }

  // Revenue Chart
  const optionsRevenueChart = {
    series: [
      {
        name: "Sales",
        data: [34, 29, 32, 38, 39, 35, 36],
      },
    ],
    chart: {
      type: "bar",
      width: "100%",
      height: 140,
      sparkline: {
        enabled: true,
      },
    },
    theme: {
      monochrome: {
        enabled: true,
        color: "#31316A",
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "25%",
        borderRadius: 5,
        radiusOnLastStackedBar: true,
        colors: {
          backgroundBarColors: ["#F2F4F6", "#F2F4F6", "#F2F4F6", "#F2F4F6"],
          backgroundBarRadius: 5,
        },
      },
    },
    labels: [1, 2, 3, 4, 5, 6, 7],
    xaxis: {
      categories: ["01 Feb", "02 Feb", "03 Feb", "04 Feb", "05 Feb", "06 Feb", "07 Feb"],
      crosshairs: {
        width: 1,
      },
    },
    tooltip: {
      fillSeriesColor: false,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      theme: "light",
      style: {
        fontSize: "12px",
        fontFamily: "Inter",
      },
      y: {
        formatter: function (val) {
          return "$ " + val + "k";
        },
      },
    },
  };

  const revenueChartEl = document.getElementById("chart-revenue");
  if (revenueChartEl) {
    const revenueChart = new ApexCharts(revenueChartEl, optionsRevenueChart);
    revenueChart.render();
  }

  //Traffic volumes
  const optionsTrafficVolumesChart = {
    series: [
      {
        name: "Direct",
        data: [7100, 9600, 10000, 8700, 12000, 15400, 19000],
      },
      {
        name: "Refferals",
        data: [4100, 6800, 7000, 6700, 7200, 14000, 12000],
      },
      {
        name: "Organic",
        data: [1100, 3200, 4500, 3200, 3400, 5200, 4100],
      },
    ],
    colors: ["#4D4AE8", "#FD8E7A", "#06A77D", "#51449E"],
    chart: {
      height: 420,
      type: "line",
      fontFamily: "Inter",
      foreColor: "#4B5563",
      toolbar: {
        show: true,
        offsetX: 0,
        offsetY: 0,
        tools: {
          download: false,
          selection: false,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: false,
          reset: '<img src="/static/icons/reset.png" width="20">',
          customIcons: [],
        },
        export: {
          csv: {
            filename: undefined,
            columnDelimiter: ",",
            headerCategory: "category",
            headerValue: "value",
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString();
            },
          },
        },
        autoSelected: "zoom",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    grid: {
      show: true,
      borderColor: "#f2f2f2",
      strokeDashArray: 1,
    },
    xaxis: {
      categories: ["01 Feb", "02 Feb", "03 Feb", "04 Feb", "05 Feb", "06 Feb", "07 Feb"],
      labels: {
        style: {
          fontSize: "12px",
          fontWeight: 500,
        },
      },
      axisBorder: {
        color: "#ffffff",
      },
      axisTicks: {
        color: "#ffffff",
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: ["#4B5563"],
          fontSize: "12px",
          fontWeight: 500,
        },
      },
    },
    legend: {
      show: true,
      fontSize: "14px",
      fontFamily: "Inter",
      fontWeight: 400,
      height: 60,
      tooltipHoverFormatter: undefined,
      offsetY: 20,
      markers: {
        width: 14,
        height: 14,
        strokeWidth: 1,
        strokeColor: "#fff",
        radius: 50,
      },
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          yaxis: {
            show: false,
          },
        },
      },
    ],
  };

  const trafficVolumesChartEl = document.getElementById("traffic-volumes-chart");
  if (trafficVolumesChartEl) {
    const trafficVolumesChart = new ApexCharts(trafficVolumesChartEl, optionsTrafficVolumesChart);
    trafficVolumesChart.render();
  }

  // Sales by Product
  const optionsTrafficShareChart = {
    series: [
      {
        name: "Visits",
        data: [4, 7, 9, 29, 51],
      },
    ],
    chart: {
      type: "bar",
      height: 500,
      foreColor: "#4B5563",
      fontFamily: "Inter",
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: false,
        barHeight: "90%",
        borderRadius: 10,
        colors: {
          backgroundBarColors: ["#fff"],
          backgroundBarOpacity: 0.2,
          backgroundBarRadius: 10,
        },
      },
    },
    colors: ["#4D4AE8"],
    dataLabels: {
      enabled: true,
      textAnchor: "middle",
      formatter: function (val, opt) {
        return opt.w.globals.labels[opt.dataPointIndex];
      },
      offsetY: -1,
      dropShadow: {
        enabled: false,
      },
      style: {
        fontSize: "12px",
        fontFamily: "Inter",
        fontWeight: "500",
      },
    },
    grid: {
      show: false,
      borderColor: "#f2f2f2",
      strokeDashArray: 1,
    },
    legend: {
      show: false,
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    tooltip: {
      fillSeriesColor: false,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      theme: "light",
      style: {
        fontSize: "12px",
        fontFamily: "Inter",
      },
      y: {
        formatter: function (val) {
          return val + "%";
        },
      },
    },
    xaxis: {
      categories: ["Mail", "Social", "Organic", "Referrals", "Direct"],
      labels: {
        style: {
          fontSize: "12px",
          fontWeight: 500,
        },
        offsetY: 5,
      },
      axisBorder: {
        color: "#ffffff",
      },
      axisTicks: {
        color: "#ffffff",
        offsetY: 5,
      },
    },
  };

  const trafficShareChartEl = document.getElementById("traffic-share-chart");
  if (trafficShareChartEl) {
    const trafficShareChart = new ApexCharts(trafficShareChartEl, optionsTrafficShareChart);
    trafficShareChart.render();
  }

  // Total Orders Chart
  const optionsAppRankingChart = {
    series: [
      {
        name: "Travel & Local",
        data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
      },
      {
        name: "Widgets",
        data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
      },
    ],
    chart: {
      type: "bar",
      height: "400px",
      fontFamily: "Inter",
      foreColor: "#4B5563",
    },
    colors: ["#f0bc74", "#31316A"],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "40%",
        borderRadius: 10,
        colors: {
          backgroundBarColors: ["#fff"],
          backgroundBarOpacity: 0.2,
          backgroundBarRadius: 10,
        },
      },
    },
    grid: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
      fontSize: "14px",
      fontFamily: "Inter",
      fontWeight: 500,
      height: 40,
      tooltipHoverFormatter: undefined,
      offsetY: 10,
      markers: {
        width: 14,
        height: 14,
        strokeWidth: 1,
        strokeColor: "#ffffff",
        radius: 50,
      },
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: ["Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct"],
      labels: {
        style: {
          fontSize: "12px",
          fontWeight: 500,
        },
      },
      axisBorder: {
        color: "#EBE3EE",
      },
      axisTicks: {
        color: "#f1f1f1",
      },
    },
    yaxis: {
      show: false,
    },
    fill: {
      opacity: 1,
    },
    responsive: [
      {
        breakpoint: 1499,
        options: {
          chart: {
            height: "400px",
          },
        },
      },
    ],
  };

  const appRankingChartEl = document.getElementById("chart-app-ranking");
  if (appRankingChartEl) {
    const appRankingChart = new ApexCharts(appRankingChartEl, optionsAppRankingChart);
    appRankingChart.render();
  }

  const loadOnClickButton = document.getElementById("loadOnClick");
  if (loadOnClickButton) {
    loadOnClickButton.addEventListener("click", function () {
      const button = this;
      const loadContent = document.getElementById("extraContent");
      const allLoaded = document.getElementById("allLoadedText");

      button.classList.add("btn-loading");
      button.setAttribute("disabled", "true");

      setTimeout(() => {
        if (loadContent) loadContent.style.display = "block";
        button.style.display = "none";
        if (allLoaded) allLoaded.style.display = "block";
      }, 1500);
    });
  }

  // SVG Map
  if (document.querySelector("#map")) {
    new svgMap({
      // eslint-disable-line no-undef
      targetElementID: "map",
      colorMin: "#FCE1C3",
      colorMax: "#F8BD7A",
      flagType: "emoji",
      data: {
        data: {
          visitors: {
            name: "Visitors",
            format: "{0} visitors",
            thousandSeparator: ",",
            thresholdMax: 500000,
            thresholdMin: 0,
          },
          change: {
            name: "Change by month",
            format: "{0} %",
          },
        },
        applyData: "visitors",
        values: {
          US: { visitors: 272109, change: 4.73 },
          CA: { visitors: 160064, change: 11.09 },
          DE: { visitors: 120048, change: -2.3 },
          GB: { visitors: 110048, change: 3.3 },
          FR: { visitors: 100048, change: 1.3 },
          ES: { visitors: 90048, change: 1.5 },
          JP: { visitors: 56022, change: 3.5 },
          IT: { visitors: 48019, change: 1 },
          NL: { visitors: 40016, change: 2 },
          RU: { visitors: 30016, change: 3.4 },
          CN: { visitors: 50016, change: 6 },
          IN: { visitors: 140016, change: 2 },
          BR: { visitors: 40016, change: 5 },
          // ...
        },
      },
    });
  }

  const currentYearEl = document.querySelector(".current-year");
  if (currentYearEl) {
    currentYearEl.textContent = new Date().getFullYear().toString();
  }

  // Glide JS
  if (document.querySelector(".glide") && typeof Glide !== "undefined") {
    new Glide(".glide", {
      // eslint-disable-line no-undef
      type: "carousel",
      startAt: 0,
      perView: 3,
    }).mount();
  }

  if (document.querySelector(".glide-testimonials") && typeof Glide !== "undefined") {
    new Glide(".glide-testimonials", {
      // eslint-disable-line no-undef
      type: "carousel",
      startAt: 0,
      perView: 1,
      autoplay: 2000,
    }).mount();
  }

  if (document.querySelector(".glide-clients") && typeof Glide !== "undefined") {
    new Glide(".glide-clients", {
      // eslint-disable-line no-undef
      type: "carousel",
      startAt: 0,
      perView: 5,
      autoplay: 2000,
    }).mount();
  }

  if (document.querySelector(".glide-news-widget") && typeof Glide !== "undefined") {
    new Glide(".glide-news-widget", {
      // eslint-disable-line no-undef
      type: "carousel",
      startAt: 0,
      perView: 1,
      autoplay: 2000,
    }).mount();
  }

  if (document.querySelector(".glide-autoplay") && typeof Glide !== "undefined") {
    new Glide(".glide-autoplay", {
      // eslint-disable-line no-undef
      type: "carousel",
      startAt: 0,
      perView: 3,
      autoplay: 2000,
    }).mount();
  }

  /*

    Check out the styles here: https://www.mapbox.com/maps/streets
    To change the style of the map change the mapboxId attribute with the following available styles:

    mapbox/dark-v10, mapbox/light-v10, mapbox/streets-v11, mapbox/outdoors/v-11, mapbox/satellite-streets-v11

    This is based on the URL you can when clicking on the preview link from Mapbox.

    You need to generate your own mapboxToken by creating an account. This token will NOT work for your website, you need to generate your own one!

    */

  const mapboxConfig = {
    mapboxToken:
      "pk.eyJ1Ijoiem9sdGFudGhlbWVzYmVyZyIsImEiOiJjazZqaWUwcWswYTBvM21td2Jmcm5mYmdyIn0.7_5YCbbOFRnvqZzCNDo9fw",
    mapboxId: "mapbox/light-v10",
  };

  const baseLatLng = [37.57, -122.26];
  const mapZoom = 10;
  const mapListingsData = [
    {
      url: "#",
      latLng: [37.7, -122.41],
      name: "Call with Jane",
      date: "Tomorrow at 12:30 PM",
    },
    {
      url: "#",
      latLng: [37.59, -122.39],
      name: "HackTM conference",
      date: "In about 5 minutes",
    },
    {
      url: "#",
      latLng: [37.52, -122.29],
      name: "Marketing event",
      date: "Today at 1:00 PM",
    },
    {
      url: "#",
      latLng: [37.37, -122.12],
      name: "Dinner with partners",
      date: "In 2 hours",
    },
    {
      url: "#",
      latLng: [37.36, -121.94],
      name: "Interview with Google",
      date: "In two days at 15:00 PM",
    },
  ];

  if (document.querySelector("#mapbox") && typeof L !== "undefined") {
    const mapIcon = L.icon({
      iconUrl: "../assets/img/marker.svg",
      iconSize: [38, 95], // size of the icon
      shadowSize: [50, 64], // size of the shadow
      iconAnchor: [22, 94], // point of the icon which will correspond to marker's location
      shadowAnchor: [4, 62], // the same for the shadow
      popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
    });

    const mapListings = L.map("mapbox").setView(baseLatLng, mapZoom);
    L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
      {
        attribution:
          'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 18,
        id: mapboxConfig.mapboxId,
        accessToken: mapboxConfig.mapboxToken,
      },
    ).addTo(mapListings);

    mapListingsData.forEach((listing) => {
      const popupHtml = `
        <a href="${listing.url}" class="card card-article-wide border-0 flex-column no-gutters no-hover">
            <div class="card-body py-0 d-flex flex-column justify-content-between col-12">
                <h4 class="h5 fw-normal mb-2">${listing.name}</h4>
                <div class="d-flex"><div class="icon icon-xs icon-tertiary me-2"><span class="fas fa-clock"></span></div><div class="font-xs text-dark">${listing.date}</div></div>
            </div>
        </a>
      `;
      const marker = L.marker(listing.latLng, { icon: mapIcon }).addTo(mapListings);
      marker.bindPopup(popupHtml);
    });
  }

  // Choices.js
  const selectStateInputEl = document.querySelector("#state");
  if (selectStateInputEl && typeof Choices !== "undefined") {
    const choices = new Choices(selectStateInputEl); // eslint-disable-line no-unused-vars
  }

  // Sortable Js
  if (document.body.clientWidth > breakpoints.lg && typeof Sortable !== "undefined") {
    const kanbanColumn1 = document.getElementById("kanbanColumn1");
    if (kanbanColumn1) {
      new Sortable(kanbanColumn1, { group: "shared" }); // eslint-disable-line no-new
    }

    const kanbanColumn2 = document.getElementById("kanbanColumn2");
    if (kanbanColumn2) {
      new Sortable(kanbanColumn2, { group: "shared" }); // eslint-disable-line no-new
    }

    const kanbanColumn3 = document.getElementById("kanbanColumn3");
    if (kanbanColumn3) {
      new Sortable(kanbanColumn3, { group: "shared" }); // eslint-disable-line no-new
    }

    const kanbanColumn4 = document.getElementById("kanbanColumn4");
    if (kanbanColumn4) {
      new Sortable(kanbanColumn4, { group: "shared" }); // eslint-disable-line no-new
    }
  }

  // multiple
  const selectStatesInputEl = document.querySelector("#states");
  if (selectStatesInputEl && typeof Choices !== "undefined") {
    const choices = new Choices(selectStatesInputEl); // eslint-disable-line no-unused-vars
  }

  // Pricing countup
  const billingSwitchEl = document.getElementById("billingSwitch");
  if (billingSwitchEl && typeof countUp !== "undefined") {
    const countUpStandard = new countUp.CountUp("priceStandard", 99, {
      startVal: 199,
    });
    const countUpPremium = new countUp.CountUp("pricePremium", 199, {
      startVal: 299,
    });

    billingSwitchEl.addEventListener("change", () => {
      if (billingSwitchEl.checked) {
        countUpStandard.start();
        countUpPremium.start();
      } else {
        countUpStandard.reset();
        countUpPremium.reset();
      }
    });
  }
});
